import React, { Component } from 'react';
import actions from '../../redux/actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import SearchView from './search-form-view';
import moment from 'moment';

class SearchContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: {
                city: false,
                region: false,
                dates: false,
                rooms: ''
            },
            selectedCountry: null,
            selectedCountryRegion: null,
            selectedCity: null,
            selectedLocation: null,
            selectedHotel: null,
            dates: {
                checkIn: moment().add(1, 'day'),
                checkOut: moment().add(2, 'day')
            },
            roomsAmount: {
                single: 0,
                double: 1,
                triple: 0,
                quad: 0,
                extraBeds: 0
            },
            searchQueryId:''
        };

        this.onCountryChange = this.onCountryChange.bind(this);
        this.onRegionChange = this.onRegionChange.bind(this);
        this.onCityChange = this.onCityChange.bind(this);
        this.onLocationChange = this.onLocationChange.bind(this);
        this.onHotelChange = this.onHotelChange.bind(this);
        this.onDatesChange = this.onDatesChange.bind(this);
        this.onRoomAmountChange = this.onRoomAmountChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onClearSearch = this.onClearSearch.bind(this);
    }

    onCountryChange(country) {
        if (country === null)
            this.setState(
                update(this.state, {
                    selectedCountry: { $set: null },
                    selectedCountryRegion: { $set: null }
                })
            );
        else
            this.setState(
                update(this.state, {
                    selectedCountry: { $set: country }
                })
            );
    }

    onRegionChange(region) {
        if (region === null) {
            this.setState(
                update(this.state, {
                    selectedCountryRegion: { $set: null }
                })
            );
        } else {
            this.setState(
                update(this.state, {
                    selectedCountry: { $set: region.country },
                    selectedCountryRegion: { $set: region },
                    hasError: { region: { $set: false }, city: { $set: false } }
                })
            );
        }
    }

    onCityChange(city) {
        if (city === null) {
            this.setState(
                update(this.state, {
                    selectedCity: { $set: null },
                    selectedCountryRegion: { $set: null }
                })
            );
        } else {
            this.setState(
                update(this.state, {
                    selectedCity: { $set: city },
                    selectedCountry: { $set: city.country },
                    selectedCountryRegion: {
                        $set: city.primaryCountryRegion || city.secondaryCountryRegion
                    },
                    hasError: { city: { $set: false } }
                })
            );
        }
    }

    onLocationChange(location) {
        this.setState(
            update(this.state, {
                selectedLocation: { $set: location }
            })
        );
    }

    onHotelChange(hotel) {
        if (hotel === null) this.setState({ selectedHotel: hotel });
        else
            this.setState(
                update(this.state, {
                    selectedHotel: { $set: hotel },
                    selectedCountry: { $set: hotel.country },
                    selectedCountryRegion: { $set: hotel.city.primaryCountryRegion },
                    selectedCity: { $set: hotel.city },
                    selectedLocation: { $set: hotel.address.cityArea }
                })
            );
    }

    onDatesChange(startDate, endDate) {
        if (!startDate && !endDate) {
            this.setState(update(this.state, { hasError: { dates: { $set: true } } }));
        } else {
            this.setState(
                update(this.state, {
                    dates: {
                        checkIn: { $set: startDate },
                        checkOut: { $set: endDate }
                    },
                    hasError: { dates: { $set: false } }
                })
            );
        }
    }

    onRoomAmountChange(roomType, value) {

        let roomsAmount = {...this.state.roomsAmount};
        roomsAmount[roomType] = value;
        let totalRoom = 0;
        let totalPax = 0;

        for (const [key, value] of Object.entries(roomsAmount)){
            if (key !== 'extraBeds')
                totalRoom += value;
            switch (key) {
                case 'single':
                    totalPax += value;
                    break;
                case 'double':
                    totalPax += value * 2;
                    break;
                case 'triple':
                    totalPax += value * 3;
                    break;
                case 'quad':
                    totalPax += value * 4;
                    break;
            }   
        }

        if (totalRoom > 5)
            this.setState(update(this.state, {
                hasError: {
                    rooms: {$set:'Warning: Total maximum of 5 rooms allowed.'}
                },
                roomsAmount:{[roomType]: { $set:this.state.roomsAmount[roomType] }}
            }));
        else if (totalPax > 9)
            this.setState(update(this.state, {
                hasError: {
                    rooms: {$set:'Warning: Total maximum of 9 passengers allowed.'}
                },
                roomsAmount:{[roomType]: { $set:this.state.roomsAmount[roomType] }}
            }));
        else
            this.setState(
                update(this.state, { 
                    roomsAmount: { [roomType]: { $set: value } },
                    hasError: { rooms: { $set: false } } 
                })
            );
    }

    isSearchValid() {
        const { selectedCountryRegion, selectedCity, dates, roomsAmount } = this.state;
        let updatedObj = { ...this.state.hasError };
        let status = true;

        for (let key in updatedObj) {
            if (updatedObj.hasOwnProperty(key)) {
                updatedObj[key] = false;
            }
        }

        if (!selectedCountryRegion && !selectedCity) {
            updatedObj.city = true;
            status = false;
        }
        if (!dates.checkIn || !dates.checkOut) {
            updatedObj.dates = true;
            status = false;
        }
        if (
            roomsAmount.single === 0 &&
            roomsAmount.double === 0 &&
            roomsAmount.triple === 0 &&
            roomsAmount.quad === 0
        ) {
            updatedObj.rooms = 'Room is required. Please, set at least one room.';
            status = false;
        }

        this.setState(update(this.state, { hasError: { $set: updatedObj } }));
        return status;
    }

    onSearch() {
        const {
            selectedCountry,
            selectedCountryRegion,
            selectedLocation,
            selectedCity,
            selectedHotel,
            roomsAmount,
            dates: { checkIn, checkOut }
        } = this.state;

        if (!this.isSearchValid()) return;

        const requestData = {
            
            pageSize: 25,
            pageNumber: 0,
            searchQueryId: '',
            SortExpression:'',
            FilterExpression: '',
            data:{
                countryCode: selectedCountry.code,
                countryRegionCode: selectedCountryRegion?.code,
                cityCode: selectedCity.code,
                cityAreaCode: selectedLocation?.code,
                hotelName:selectedHotel?.name,
                ediCode: selectedHotel?.code,
                roomsRequired: [roomsAmount],
                checkIn: { checkInTime: checkIn, checkOutTime: checkOut }
            }
        };

        this.props.actions.getHotelAvailabilityXmlRequest(requestData);
    }

    onClearSearch() {
        this.setState(
            update(this.state, {
                hasError: {
                    city: { $set: false },
                    rooms: { $set: false },
                    dates: { $set: false },
                    region: { $set: false }
                },
                selectedCountry: { $set: null },
                selectedCountryRegion: { $set: null },
                selectedCity: { $set: null },
                selectedLocation: { $set: null },
                selectedHotel: { $set: null },
                dates: {
                    checkIn: { $set: moment().add(1, 'day') },
                    checkOut: { $set: moment().add(2, 'day') }
                },
                roomsAmount: {
                    single: { $set: 0 },
                    double: { $set: 1 },
                    extraBeds: { $set: 0 },
                    triple: { $set: 0 },
                    quad: { $set: 0 }
                }
            })
        );
        this.props.actions.clearXmlRequest();
    }

    render() {
        return (
            <SearchView
                onCountryChange={this.onCountryChange}
                onRegionChange={this.onRegionChange}
                onCityChange={this.onCityChange}
                onLocationChange={this.onLocationChange}
                onHotelChange={this.onHotelChange}
                onDatesChange={this.onDatesChange}
                onRoomAmountChange={this.onRoomAmountChange}
                onSearch={this.onSearch}
                onClearForm={this.onClearSearch}
                {...this.state}
                token={this.props.token}
                settings={this.props.settings}
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        settings: state.settings,
        token: state.oidc.user !== null ? state.oidc.user.id_token : ''
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchContainer);
